import {
  USER
} from '@lba-dev/package.local-globals/permissions';

import componentLoader from '../../componentLoader';

export const ListPreSAVIntervention = componentLoader(() =>
  import(
    /* webpackChunkName: "ListPreSAVIntervention" */
    '../../views/List/ListPreSAVIntervention'
  )
);

export const DisplayPreSAVIntervention = componentLoader(() =>
  import(
    /* webpackChunkName: "DisplaySavIntervention" */
    '../../views/DisplaySavIntervention'
  )
);

export default [
  {
    path: '/preSavIntervention/list/:filter/:query',
    component: ListPreSAVIntervention,
    restrictions: () => USER,
  },
  {
    path: '/preSavIntervention/list/:filter',
    component: ListPreSAVIntervention,
    restrictions: () => USER,
  },
  {
    path: '/preSavIntervention/:id',
    component: DisplayPreSAVIntervention,
    restrictions: () => USER,
  },
];
